import {createContext, useContext} from 'react'
import {ar} from './ar'
import {de} from './de'
import {en} from './en'
import {es} from './es'
import {fr} from './fr'
import {hi} from './hi'
import {it} from './it'
import {ja} from './ja'
import {ko} from './ko'
import {nl} from './nl'
import {pl} from './pl'
import {pt} from './pt'
import {ru} from './ru'
import {sv} from './sv'
import {tr} from './tr'
import {zh} from './zh'
import type {InterfaceStrings} from './strings'

/** One per language the session speaks (`data/languages.ts`), English counted once. */
export const CATALOGUE = {ar, de, en, es, fr, hi, it, ja, ko, nl, pl, pt, ru, sv, tr, zh} satisfies Record<
    string,
    InterfaceStrings
>

export type InterfaceLang = keyof typeof CATALOGUE

/** A page language (`en`, `ja`) or a session language (`en-uk`, `pt`) → its catalogue, English when it has none. */
export function interfaceLang(code: string | null | undefined): InterfaceLang {
    const primary = code?.toLowerCase().split('-')[0] ?? ''
    return primary in CATALOGUE ? (primary as InterfaceLang) : 'en'
}

/**
 * The interface's language: the page's own, which the layout provides from the path, or the one chosen in the
 * session, which the session page provides over it. English where nothing provides one.
 */
export const InterfaceLanguage = createContext<string | null>(null)

export function useInterfaceStrings(): {lang: InterfaceLang; t: InterfaceStrings} {
    const lang = interfaceLang(useContext(InterfaceLanguage))
    return {lang, t: CATALOGUE[lang]}
}
